import React, { Component, useState } from "react";

export function DateTimeToLocal(isoDate)  {
    var d = new Date(isoDate);
    return d.toLocaleDateString() + " " + d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
}

export function MultiselectGetOptions(rawData) {
    var options = new Array();
    rawData.forEach(element => {
        options.push({ value: element.id, label: element.name });
    });
    return options;
}

export function MultiselectGetDefaultValues(rawData, selectedValues){
    var SelectedValues = [];
    rawData.forEach(Data => {
        if (selectedValues.includes(Data.id)) SelectedValues.push({ value: Data.id, label: Data.name });
    });
    return SelectedValues;
}

export function escapedNewLineToLineBreakTag(string){
    return string.split("\\n").join("\n");
}

export function ConcatLocalDateAndTime2ISO(LocalDateString, LocalTimeString ='02:00:00'){
    try {
        var LocalDateString = LocalDateString+"T"+LocalTimeString;
        var d = new Date(LocalDateString)
        return d.toISOString();
    } catch {
        var d = new Date();
        return d.toISOString();
    }
} 

export function SplitRQs(inData){
    return inData.map((Rq) => {
        return <><a key={Rq.Id} >{Rq.Identifier}</a>&nbsp;&nbsp;</>;
    });      
}

  const date_diff_indays = function (date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor(
      (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
        Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
        (1000 * 60 * 60 * 24)
    );
  };

export function SplitoutLocalDateFromISO_(isoDate, redLight=false){
    var d = new Date(isoDate);
    const date = new Date();
    date.setDate(date.getDate() - 1);
    if (redLight==true && d < date ) {            
        return <font style={{color:'red'}}>{d.toLocaleDateString()}</font>;
    } else {
        return d.toLocaleDateString();
    }
}  

export function SplitoutLocalDateFromISO(isoDate, redLight=false){
    var expectedDeliveryDate = new Date(isoDate);
    const date = new Date();
    date.setDate(date.getDate() -1);

    var daysDiff =   date_diff_indays(date, expectedDeliveryDate);
    console.log(daysDiff);

    if (redLight==true ) {        
        // if (redLight==true && daysDiff < 1 ) return <font style={{color:"#ff0000"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
        // if (redLight==true && daysDiff < 2 ) return <font style={{color:"#FF2200"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
        // if (redLight==true && daysDiff < 3 ) return <font style={{color:"#FF4400"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
        // if (redLight==true && daysDiff < 4 ) return <font style={{color:"#FF6600"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
        // if (redLight==true && daysDiff < 5 ) return <font style={{color:"#FF8800"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
        // if (redLight==true && daysDiff < 6 ) return <font style={{color:"#FFA200"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;

        if (redLight==true && daysDiff < 2 ) return <font style={{color:"#FF0000"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
        if (redLight==true && daysDiff < 4 ) return <font style={{color:"#4444ff"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;

        return <font style={{color:"#000000"}}>{expectedDeliveryDate.toLocaleDateString()}</font>;
    } else {
        return expectedDeliveryDate.toLocaleDateString();
    }
}  

export function SplitoutLocalTimeFromISO(isoDate){
    if (isoDate.length <= 8 ) isoDate = '1900-01-01T'+isoDate+"Z";
    var d = new Date(isoDate);
    return d.toLocaleTimeString([],  {hour: '2-digit', minute:'2-digit'});
}

export function getOptions(object){
    return object.map((state) => {
        return <option key={state.Id} value={state.Id}>{state.Name}{state.Title}</option>;
    });
}    

export function metaLookUpTitle(metadata, id){    
    var Result = "";
    try {
        var Title = metadata.find((element) => element.Id == id).Title;
        if (Title!=undefined) Result += Title;
    } catch {}

    try {
        var Name = metadata.find((element) => element.Id == id).Name;
        if (Name!=undefined) Result += Name;
    } catch {}

    return Result;
}    